import React, {Component} from 'react';
import {Switch} from "../../buttons/Swtich";
import {
    HAS_ACTIONS_EXTRA_DATA
} from "../../dashboard/metrics";
import {MetricCombobox} from "../../dashboard/MetricCombobox";
import {DecimalInput} from "../../elements/DecimalInput";
import {EditMetricConversionConfigurationModalButton} from "./EditMetricConversionConfigurationModalButton";
import {ANALYTICS_CHANNEL, CHANNEL_INFO_BY_CHANNEL} from "../../channels/channels";
import AdAccountsItems from "../../elements/AdAccountsItems";
import {APIClient} from "../../../utils/APIClient";
import {API_URL} from "../../../settings/local_settings";
import {Spinner} from "../../Spinner";
import {AdAccountsActionDataHandler} from "../../AdAccountsActionDataHandler";
import {fetchCustomMetrics, filterForGoals} from "../../../hooks/useCustomMetrics";
import { withTranslation } from 'react-i18next';

export const CONVERSION_TYPE_USE_ACTIONS_FROM_BUSINESS_UNIT = "USE_ACTIONS_FROM_BUDGET";
export const CONVERSION_TYPE_ACTIONS_SELECTED_FOR_GOAL = "ACTIONS_SELECTED_FOR_GOAL"

class GoalConfigurationClass extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isEnabled: this.props.data !== null,
            metricName: this.getMetricName(),
            value: this.getValue(),
            metricConversionConfiguration: this.getMetricConversionConfiguration(),
            adAccountsActionData: this.getAdAccountActionData(),
            customMetrics: []
        }

        this.handleSwitchChange = this.handleSwitchChange.bind(this);
        this.handleSelectedOptionMetricNameChange = this.handleSelectedOptionMetricNameChange.bind(this);
        this.handleValueChange = this.handleValueChange.bind(this);
        this.handleMetricConversionConfigurationChange = this.handleMetricConversionConfigurationChange.bind(this);
    }

    componentDidMount() {
        if(this.state.adAccountsActionData === null) {
            this.getAdAccountsActionDataFromBusinessUnit();
        } else if (this.state.adAccountsActionData.data) {
            // Handler ya vino por prop (caso BusinessUnitGlobalInfo / PortalBudgets):
            // lazy-load igual los counts GA4 para que aparezcan los badges en el modal.
            const rawData = this.state.adAccountsActionData.data;
            this.setState({adAccountsRawData: rawData});
            this.maybeLoadGA4CountsForAccounts(rawData);
        }
        // Fix rZfzxVQB: hidratar custom metrics para que aparezcan en MetricCombobox.
        // Mismo patrón que MetricsSelect (FlexIndicators). Solo las is_goals_evaluable.
        fetchCustomMetrics().then((items) => {
            this.setState({customMetrics: filterForGoals(items)});
        });
    }

    getAdAccountsActionDataFromBusinessUnit () {
        const { t } = this.props;
        const url = this.getAdAccountsActionDataFromBusinessUnitUrl();

        new APIClient(url).call('GET', {}).then((response) => {
            this.setState({saving: false});
            if (response.status === 'ERROR') {
                alert(response['error_message']);
            } else if (response.status === 'OK') {
                const adAccountsData = response.data;
                this.setState({
                    adAccountsRawData: adAccountsData,
                    adAccountsActionData: new AdAccountsActionDataHandler(adAccountsData, t)
                });
                this.maybeLoadGA4CountsForAccounts(adAccountsData);
            }
        })
    }

    maybeLoadGA4CountsForAccounts(adAccountsData) {
        // Lazy-load: para cada ad_account ANALYTICS, traer counts 1D/7D/30D del
        // endpoint /actions/counts (cache Firestore 24h en backend) y mergearlos
        // en action_data por action_id. CategorizedActionsSelect renderiza los
        // badges si los items tienen `counts`.
        const analyticsAccounts = (adAccountsData || []).filter(a => a && a.channel === ANALYTICS_CHANNEL);
        if (analyticsAccounts.length === 0) {
            console.debug('[GA4 counts] No hay cuentas ANALYTICS en este BU; nada que cargar.', {channels: (adAccountsData || []).map(a => a && a.channel)});
            return;
        }
        analyticsAccounts.forEach((accountData) => {
            const url = `${API_URL}agency/ad-accounts/${accountData.ad_account_id}/actions/counts`;
            console.debug('[GA4 counts] Fetching', url);
            new APIClient(url).call('GET').then((response) => {
                if (response.status !== 'OK') {
                    console.warn('[GA4 counts] Endpoint respondió non-OK', {ad_account_id: accountData.ad_account_id, response});
                    return;
                }
                if (!response.data || Object.keys(response.data).length === 0) {
                    console.warn('[GA4 counts] Endpoint OK pero counts vacíos (cache vacío o GA4 sin datos)', {ad_account_id: accountData.ad_account_id});
                    return;
                }
                console.debug('[GA4 counts] Mergeando counts', {ad_account_id: accountData.ad_account_id, counts: response.data});
                this.mergeGA4CountsIntoAccount(accountData.ad_account_id, response.data);
            }).catch((err) => {
                console.error('[GA4 counts] Falló el request', {ad_account_id: accountData.ad_account_id, err});
            });
        });
    }

    mergeGA4CountsIntoAccount(adAccountId, countsByActionId) {
        const { t } = this.props;
        this.setState((prevState) => {
            const rawData = prevState.adAccountsRawData;
            if (!rawData) return null;
            const newRawData = rawData.map((acc) => {
                if (acc.ad_account_id !== adAccountId) return acc;
                const newActionData = (acc.action_data || []).map((action) => {
                    const counts = countsByActionId[action.action_id];
                    return counts ? {...action, counts} : action;
                });
                return {...acc, action_data: newActionData};
            });
            return {
                adAccountsRawData: newRawData,
                adAccountsActionData: new AdAccountsActionDataHandler(newRawData, t),
            };
        });
    }

    getAdAccountsActionDataFromBusinessUnitUrl() {
        return API_URL + `business-unit/${this.props.businessUnitId}/ad-accounts-data/`;
    }

    getAdAccountActionData() {
        if(this.props.adAccountsActionData !== undefined)
            return this.props.adAccountsActionData;
        return null;
    }

    handleMetricConversionConfigurationChange(conversionType, actionConfigByBuccId) {
        const metricConversionConfiguration = this.state.metricConversionConfiguration;
        metricConversionConfiguration["type"] = conversionType;

        const actionConfigurationByBucc = {};
        Object.keys(actionConfigByBuccId).forEach(buccId => {
            const config = actionConfigByBuccId[buccId];
            actionConfigurationByBucc[buccId.toString()] = {
                "use_ad_account_all_primary_conversions": config.use_ad_account_all_primary_conversions === true,
                "action_ids": config.action_ids
            };
        });
        metricConversionConfiguration["action_configuration_by_bucc_id"] = actionConfigurationByBucc;

        this.setState({
            ...this.state,
            metricConversionConfiguration: metricConversionConfiguration
        });
        this.props.onChange({
            "metricName": this.state.metricName,
            "value": this.state.value,
            "metricConversionConfiguration": metricConversionConfiguration
        });
    }

    handleSwitchChange(event) {
        const isActive = event.target.checked;

        if (!isActive) {
            this.setState({
                isEnabled: false,
                metricName: null
            });
            this.props.onChange(null);
        } else {
            this.setState({
                isEnabled: true
            });
            this.props.onChange({
                "metricName": this.state.metricName,
                "value": this.state.value,
                "metricConversionConfiguration": this.state.metricConversionConfiguration
            });
        }
    }

    handleSelectedOptionMetricNameChange(event) {
        const metricName = event.target.value;
        let metricConversionConfiguration = this.state.metricConversionConfiguration;

        if(HAS_ACTIONS_EXTRA_DATA.includes(metricName) && metricConversionConfiguration === null) {
            metricConversionConfiguration = {"type": CONVERSION_TYPE_USE_ACTIONS_FROM_BUSINESS_UNIT, "action_configuration_by_bucc_id": {}};
        }

        this.setState({
            metricName: metricName,
            metricConversionConfiguration: metricConversionConfiguration
        });

        this.props.onChange({
            "metricName": metricName,
            "value": this.state.value,
            "metricConversionConfiguration": metricConversionConfiguration
        });
    }

    handleValueChange(newValue) {
        this.setState({value: newValue});
        this.props.onChange({
            "metricName": this.state.metricName, "value": newValue,
            "metricConversionConfiguration": this.state.metricConversionConfiguration
        });
    }

    isEnabled() {
        return this.props.data !== null;
    }

    getMetricName() {
        if (!this.isEnabled()) {
            return null;
        }

        return this.props.data["metricName"]
    }

    getMetricConversionConfiguration() {
        if (!this.isEnabled()) {
            return null;
        }

        return this.props.data["metricConversionConfiguration"];
    }

    getValue() {
        if (!this.isEnabled()) {
            return null;
        }
        return this.props.data["value"]
    }

    renderMetricNameInput() {
        const { t } = this.props;
        const value = !this.state.isEnabled ? null : this.state.metricName;

        return (
            <div className="col-md-7">
                <label>{t('goal_configuration.metric')}</label>
                <MetricCombobox
                    name="metricName"
                    value={value || null}
                    disabled={!this.state.isEnabled}
                    customMetrics={this.state.customMetrics}
                    // Opcional: sólo lo pasan las superficies 2.1 que conocen los canales de la
                    // línea. Sin la prop, el selector ofrece el catálogo entero, como siempre.
                    channels={this.props.channels || null}
                    onChange={(metricName) => this.handleSelectedOptionMetricNameChange({target: {value: metricName}})}
                />
            </div>
        )
    }


    renderValueInput() {
        const { t } = this.props;
        return <div className="col-md-5">
            <label>{t('goal_configuration.value')}</label>
            <DecimalInput name="value"
                                                             readOnly={!this.state.isEnabled}
                                                             onChange={this.handleValueChange}
                                                             value={this.state.value}/></div>;
    }

    isMetricWithActions() {
        return HAS_ACTIONS_EXTRA_DATA.includes(this.state.metricName);
    }

    getChannelFromBuccId(buccId) {
        return this.state.adAccountsActionData.getAdAccountsData().filter(adAccountData => (adAccountData["bucc_id"] === parseInt(buccId, 10)))[0]["channel"]
    }


    channelHasConversionMetric(channel) {
        return CHANNEL_INFO_BY_CHANNEL[channel]?.hasIncludeAllConversionsSetting === true;
    }

    convertActionsIdentifiersInAdAccountsSelectedItemsData() {
        // returns [{bucc_id, ad_account_id, ad_account_account_id, ad_account_name, channel, items: [name], empty_items_item:{"text":, "is_ok": False/True}]

        if(this.state.metricConversionConfiguration === null)
            return [];

        const actionIdsByBuccId = this.convertActionsIdentifiersInActionIdsByBuccId();

        const result = [];
        this.getFilteredAdAccountsActionData().getAdAccountsData().forEach(adAccountData => {
            const data = {
                bucc_id: adAccountData["bucc_id"],
                ad_account_id: adAccountData["ad_account_id"],
                ad_account_account_id: adAccountData["ad_account_account_id"],
                ad_account_name: adAccountData["ad_account_name"],
                channel: adAccountData["channel"],
                items: actionIdsByBuccId[adAccountData["bucc_id"]] !== undefined ? this.state.adAccountsActionData.getActionsNamesOfActionsForCampaignsConfiguration(adAccountData["bucc_id"], actionIdsByBuccId[adAccountData["bucc_id"]]): [],
                empty_items_item: this.state.adAccountsActionData.getEmptyItemsItem(adAccountData["channel"])
            }
            result.push(data);
        });
        return result;
    }

    convertActionsIdentifiersInActionIdsByBuccId() {
        const actionIdsByBuccId = {};

        if(this.state.metricConversionConfiguration === null)
            return null;

        if(this.state.metricConversionConfiguration.type === CONVERSION_TYPE_USE_ACTIONS_FROM_BUSINESS_UNIT)
            return {}

        Object.keys(this.state.metricConversionConfiguration["action_configuration_by_bucc_id"]).forEach((buccId) => {
            const actionConfiguration = this.state.metricConversionConfiguration["action_configuration_by_bucc_id"][buccId];
            actionIdsByBuccId[buccId.toString()] = actionConfiguration.use_ad_account_all_primary_conversions === true ? [] : actionConfiguration.action_ids;
        });

        return actionIdsByBuccId;
    }

    getActionConfigByBuccId() {
        if (this.state.metricConversionConfiguration === null)
            return {};

        if (this.state.metricConversionConfiguration.type === CONVERSION_TYPE_USE_ACTIONS_FROM_BUSINESS_UNIT)
            return {};

        const result = {};
        const configByBuccId = this.state.metricConversionConfiguration["action_configuration_by_bucc_id"] || {};
        Object.keys(configByBuccId).forEach((buccId) => {
            const actionConfiguration = configByBuccId[buccId];
            result[buccId.toString()] = {
                action_ids: actionConfiguration.action_ids || [],
                use_ad_account_all_primary_conversions: actionConfiguration.use_ad_account_all_primary_conversions === true,
            };
        });
        return result;
    }

    getFilteredAdAccountsActionData() {
        if(this.props.campaignsConfigurationId === undefined || this.props.campaignsConfigurationId === null)
            return this.state.adAccountsActionData;

        return this.state.adAccountsActionData.filterForCampaignsConfiguration(this.props.campaignsConfigurationId);
    }

    renderEditButton() {
        const conversionType = this.state.metricConversionConfiguration !== null ? this.state.metricConversionConfiguration.type : null;
        return <EditMetricConversionConfigurationModalButton actionConfigByBuccId={this.getActionConfigByBuccId()}
                                                             adAccountsActionData={this.getFilteredAdAccountsActionData()}
                                                             conversionType={conversionType}
                                                             onMetricConversionConfigurationEdited={this.handleMetricConversionConfigurationChange}
        />
    }

    renderConversionGoalEventsDetails() {
        if(this.state.adAccountsActionData === null)
            return <div className="box-loader">
                <Spinner color="positive"/>
            </div>;

        if (!this.isMetricWithActions())
            return null;

        let details = null;

        const { t } = this.props;
        const editButton = this.renderEditButton();
        if(this.state.metricConversionConfiguration.type === CONVERSION_TYPE_USE_ACTIONS_FROM_BUSINESS_UNIT) {
            details = t('goal_configuration.uses_control_line_events');
        } else if (this.state.metricConversionConfiguration.type === CONVERSION_TYPE_ACTIONS_SELECTED_FOR_GOAL) {
            details = t('goal_configuration.specific_goal_events');
        } else {
            throw new Error("Tipo de conversion inválida");
        }

        const actionSelectedDetails = <ul>{this.getActionSelectedDetails()}</ul>;

        return <div className="col-12 pl-3 pr-0 goal-events-detail-text">
            <div className={"type_text"}>{details}{editButton}</div>{actionSelectedDetails}
        </div>;
    }

    getActionSelectedDetails() {
        let adAccountsSelectedItemsData = null;
        if(this.state.metricConversionConfiguration.type === CONVERSION_TYPE_USE_ACTIONS_FROM_BUSINESS_UNIT)
            adAccountsSelectedItemsData = this.getFilteredAdAccountsActionData().getAdAccountsSelectedItemsData();
        else if (this.state.metricConversionConfiguration.type === CONVERSION_TYPE_ACTIONS_SELECTED_FOR_GOAL)
            adAccountsSelectedItemsData = this.convertActionsIdentifiersInAdAccountsSelectedItemsData();
        else
            throw Error("Método de selección incorrecto")

        return <AdAccountsItems adAccountsSelectedItemsData={adAccountsSelectedItemsData}/>
    }

    render() {
        return (
            <div className="row mb-4 align-items-start">
                <div className="col-md-auto">
                    {this.renderSwitch()}
                </div>
                <div className="col-md">
                    <div className="row g-3">
                        {this.renderMetricNameInput()}
                        {this.renderValueInput()}
                    </div>
                    {this.renderConversionGoalEventsDetails()}
                </div>
            </div>
        );
    }


    renderSwitch() {
        const { t } = this.props;
        return <div className="min-width-column pl-0 pr-3 pt-3">
            <div className="switch-input d-flex align-items-center">
                <Switch
                    centered={true}
                    onChange={this.handleSwitchChange}
                    checked={this.state.isEnabled}
                    name="goalIsActive"
                    messageToAlertUserIfChecked={null}
                    style={{marginLeft: "0"}}
                />
                <div>{t('goal_configuration.goal_number', { number: this.props.priority })}</div>
            </div>
        </div>;
    }
}

export const GoalConfiguration = withTranslation()(GoalConfigurationClass);
export default GoalConfiguration;
